import { withStyles } from "@material-ui/core/styles";

import React from "react";
import {
  Datagrid,
  DateField,
  List,
  ShowButton,
  TextField,
  EditButton,
  TextInput,
  SelectInput,
  NumberField,
  ReferenceField,
  ReferenceInput,
  NumberInput,
  BooleanInput,
  BooleanField,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  // TODO - add filter search

  <ReferenceInput label="Code Phage" source="id_phage" reference="phages" alwaysOn>
    <SelectInput optionText="code" />
  </ReferenceInput>,

  /* <ReferenceInput label="Generation" source="id_phage" reference="phages">
     <SelectInput optionText="generation" />
   </ReferenceInput>,
 
   <ReferenceInput label="Isolate" source="id_isolate" reference="isolates">
     <SelectInput optionText="code" />
   </ReferenceInput>,
 
   <NumberInput label="Concentration" source="concentration" />,
 
   <NumberInput label="Quantification" source="quantification" />,
 
   <TextInput label="Notes" source="notes" />,
 
   <BooleanInput label="Kills isolate?" source="kills" />,
 
   <TextInput source="intensity" />,
 
   <TextInput source="susceptibility" />,*/
];

export const PhagesHostsList = withStyles(styles)(({ classes, ...props }) => (
  <List
    title={"Phage hosts range"}
    {...props}
    filters={filters}
    // actions={<MyListActions />}
    sort={{ field: "id_phage", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={100}
  //   filter={{ is_clinical: false }}
  >
    <Datagrid>
      <ReferenceField
        label="Code Phage"
        resource="phages_hosts"
        source="id_phage"
        reference="phages"
        link="show"
      >
        <TextField source="code" />
      </ReferenceField>
      <ReferenceField
        label="Phage"
        resource="phages_hosts"
        source="id_phage"
        reference="phages"
        link="show"
      >
        <TextField source="phage" />
      </ReferenceField>
      <ReferenceField
        label="Generation"
        resource="phages_hosts"
        source="id_phage"
        reference="phages"
        link="show"
      >
        <TextField source="generation" />
      </ReferenceField>



      <BooleanField source="is_external_isolate" />

      <ReferenceField
        label="Isolate"
        resource="phages_hosts"
        source="id_isolate"
        reference="isolates"
        link="show"
      >
        <TextField source="code" />

      </ReferenceField>

      <ReferenceField
        label="External Isolate"
        resource="phages_hosts"
        source="id_external_isolate"
        reference="isolates"
        link="show"
      >
        <TextField source="code" />
      </ReferenceField>

      <NumberField label="Concentration" source="concentration" />
      <NumberField label="Quantification" source="quantification" />

      <BooleanField label="Kills?" source="kills" />
      <TextField label="Intensity" source="intensity" />
      <TextField label="Susceptibility" source="susceptibility" />

      <TextField label="Notes" source="notes" />

      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      { /* <EditButton />
      <ShowButton /> */ }
    </Datagrid>
  </List >
));
